/**
 * Swedish translations, keyed by the English source text.
 * Missing keys fall back to English; i18n.test.ts checks that every key is translated.
 */
export const sv: Record<string, string> = {
  "1 = single, 3 = triple running stitch": "1 = enkel, 3 = trippel raksöm",
  "100 stitches back": "100 stygn bakåt",
  "100 stitches forward": "100 stygn framåt",
  "360 × 350 mm (commercial)": "360 × 350 mm (industri)",
  "Action for the colour": "Åtgärd för färgen",
  "Add the image as a background and draw the shapes yourself": "Lägg in bilden som bakgrund och rita formerna själv",
  "Add to the design": "Lägg till i designen",
  "Analysing colours": "Analyserar färger",
  "Analysing…": "Analyserar…",
  "Applies to the visible motif (background and transparency removed). The aspect ratio is kept.": "Gäller det synliga motivet (bakgrund och genomskinlighet borttagna). Proportionerna behålls.",
  "Appliqué on fabric (twill)": "Applikation på tyg (twill)",
  "Area": "Yta",
  "Automatic": "Automatisk",
  "Autosave failed: {msg}. Save the project manually or download the project file.": "Automatisk sparning misslyckades: {msg}. Spara projektet manuellt eller ladda ner projektfilen.",
  "Background": "Bakgrund",
  "Background colour": "Bakgrundsfärg",
  "Black": "Svart",
  "Border": "Kant",
  "Border colour": "Kantfärg",
  "Border width (satin)": "Kantbredd (plattsöm)",
  "Brother and Baby Lock": "Brother och Baby Lock",
  "Brother and Baby Lock, PE-Design 6 and newer": "Brother och Baby Lock, PE-Design 6 och nyare",
  "By the machine's jump setting": "Enligt maskinens hoppinställning",
  "Cancel": "Avbryt",
  "Cancel digitizing": "Avbryt digitaliseringen",
  "Canvas layers": "Lager på arbetsytan",
  "Centre X": "Mittpunkt X",
  "Centre Y": "Mittpunkt Y",
  "Centre on the design": "Centrera på designen",
  "Centre run": "Mittlinje",
  "Centre the design in the hoop": "Centrera designen i ramen",
  "Changes to the current project are not saved. Discard them?": "Ändringarna i det aktuella projektet är inte sparade. Vill du kasta dem?",
  "Checking…": "Kontrollerar…",
  "Choose another image": "Välj en annan bild",
  "Choose colour…": "Välj färg…",
  "Choose end point": "Välj slutpunkt",
  "Choose or drop an image file": "Välj eller släpp en bildfil",
  "Choose start point": "Välj startpunkt",
  "Circle": "Cirkel",
  "Cleaning up colour regions": "Rensar färgområden",
  "Clear selection": "Avmarkera",
  "Click for actual size (100 %)": "Klicka för verklig storlek (100 %)",
  "Click on the canvas to choose the end point · Esc cancels": "Klicka på arbetsytan för att välja slutpunkt · Esc avbryter",
  "Click on the canvas to choose the hoop centre · Esc cancels": "Klicka på arbetsytan för att välja ramens mittpunkt · Esc avbryter",
  "Click on the canvas to choose the start point · Esc cancels": "Klicka på arbetsytan för att välja startpunkt · Esc avbryter",
  "Close": "Stäng",
  "Close dialog": "Stäng dialogrutan",
  "Close message": "Stäng meddelandet",
  "Closed line": "Sluten linje",
  "Colour": "Färg",
  "Colour changes": "Färgbyten",
  "Colour for all": "Färg för alla",
  "Colour for {name}": "Färg för {name}",
  "Colour name": "Färgnamn",
  "Colour separation": "Färgseparering",
  "Colour {n}": "Färg {n}",
  "Colour: {name}. Change colour": "Färg: {name}. Byt färg",
  "Colours": "Färger",
  "Colours and background": "Färger och bakgrund",
  "Colours are stored as the nearest colour in Brother's 64-colour PEC palette.": "Färgerna lagras som närmaste färg i Brothers PEC-palett med 64 färger.",
  "Colours are stored as the nearest colour in Janome's palette.": "Färgerna lagras som närmaste färg i Janomes palett.",
  "Column": "Kolumn",
  "Command": "Kommando",
  "Command {n} of {total}": "Kommando {n} av {total}",
  "Corner radius": "Hörnradie",
  "Could not write {format}: {error}": "Kunde inte skriva {format}: {error}",
  "Creating embroidery objects": "Skapar broderiobjekt",
  "Crop area": "Beskärningsområde",
  "Custom": "Anpassad",
  "Custom centre point": "Anpassad mittpunkt",
  "Custom…": "Anpassad…",
  "DST displacement outside ±121: ({dx}, {dy})": "DST-förflyttning utanför ±121: ({dx}, {dy})",
  "DST does not store thread colours – only colour changes. Choose the colours on the machine.": "DST lagrar inte trådfärger – bara färgbyten. Välj färgerna på maskinen.",
  "Delete": "Ta bort",
  "Density (spacing, same side)": "Täthet (avstånd, samma sida)",
  "Design canvas": "Arbetsyta",
  "Design size": "Designstorlek",
  "Design statistics": "Designstatistik",
  "Diameter": "Diameter",
  "Digitize automatically": "Digitalisera automatiskt",
  "Digitized: {n} objects in {c} colours.": "Digitaliserat: {n} objekt i {c} färger.",
  "Dimensions": "Mått",
  "Distance to the design": "Avstånd till designen",
  "Do not sew (remove)": "Sy inte (ta bort)",
  "Done": "Klar",
  "Double-click to rename": "Dubbelklicka för att byta namn",
  "Download as project file": "Ladda ner som projektfil",
  "Drag to move · Delete removes (min. {n} points) · double-click an edge to add": "Dra för att flytta · Delete tar bort (minst {n} punkter) · dubbelklicka på en kant för att lägga till",
  "Draw a shape": "Rita en form",
  "Drop an image here, or click to choose": "Släpp en bild här eller klicka för att välja",
  "Duplicate": "Duplicera",
  "EXP displacement outside ±127: {v}": "EXP-förflyttning utanför ±127: {v}",
  "EXP does not store thread colours – only colour changes.": "EXP lagrar inte trådfärger – bara färgbyten.",
  "Earlier": "Tidigare",
  "Edge run": "Kantlinje",
  "Edit": "Redigera",
  "Edit nodes": "Redigera noder",
  "Editable shapes": "Redigerbara former",
  "Ellipse (fill)": "Ellips (fyllnad)",
  "Embedded images in the SVG were skipped.": "Inbäddade bilder i SVG-filen hoppades över.",
  "Error": "Fel",
  "Estimate based on the machine settings": "Uppskattning baserad på maskininställningarna",
  "Exact RGB colours": "Exakta RGB-färger",
  "Expected VP3 block 00 0{tag} 00 at byte {pos}.": "Förväntade VP3-block 00 0{tag} 00 vid byte {pos}.",
  "Expected a CEmbOne block.": "Förväntade ett CEmbOne-block.",
  "Expected a CSewSeg block.": "Förväntade ett CSewSeg-block.",
  "Export": "Exportera",
  "Export embroidery file": "Exportera broderifil",
  "File format": "Filformat",
  "File size": "Filstorlek",
  "Fill": "Fyllnad",
  "Fill angle": "Fyllnadsvinkel",
  "Fill stitch needs a closed shape. Close the line or use running stitch.": "Fyllnadsstygn kräver en sluten form. Stäng linjen eller använd raksöm.",
  "Fill {n}": "Fyllnad {n}",
  "First": "Först",
  "Fit to window (F)": "Anpassa till fönstret (F)",
  "Follow the design": "Följ designen",
  "Fully embroidered (filled background)": "Helbroderat (fylld bakgrund)",
  "Generated stitches": "Genererade stygn",
  "Generating stitches…": "Genererar stygn…",
  "Gradients are not supported; the first colour stop is used.": "Färgövergångar (gradienter) stöds inte; första färgstoppet används.",
  "Group objects by colour": "Gruppera objekt efter färg",
  "Grows the shape so it overlaps neighbouring objects": "Förstorar formen så att den överlappar närliggande objekt",
  "Has a warning": "Har en varning",
  "Has errors": "Har fel",
  "Height": "Höjd",
  "Height (stitches)": "Höjd (stygn)",
  "Hidden objects are not sewn and are not included in the export": "Dolda objekt sys inte och tas inte med i exporten",
  "Hide (do not sew)": "Dölj (sy inte)",
  "Hide – the object is not sewn and not included in the export": "Dölj – objektet sys inte och tas inte med i exporten",
  "Hoop": "Ram",
  "Hoop (sewing field)": "Ram (sömnadsfält)",
  "Hoop and placement": "Ram och placering",
  "Hoop height": "Ramhöjd",
  "Hoop width": "Rambredd",
  "Image": "Bild",
  "Import an image (PNG, JPEG or SVG) for automatic digitizing, or draw shapes yourself with the tools on the left.": "Importera en bild (PNG, JPEG eller SVG) för automatisk digitalisering, eller rita former själv med verktygen till vänster.",
  "Import an image for automatic digitizing, or draw shapes with the tools.": "Importera en bild för automatisk digitalisering, eller rita former med verktygen.",
  "Import as vector shapes": "Importera som vektorformer",
  "Import image": "Importera bild",
  "Import project file": "Importera projektfil",
  "Imported {n} vector shapes in {c} colours.": "Importerade {n} vektorformer i {c} färger.",
  "Imported “{name}”. Save it to keep it in the browser.": "Importerade ”{name}”. Spara för att behålla det i webbläsaren.",
  "Info": "Info",
  "Inset": "Indrag",
  "Internal error in DST encoding": "Internt fel i DST-kodningen",
  "Invalid PEC offset in the PES file.": "Ogiltig PEC-offset i PES-filen.",
  "Invalid PEC stitch block signature.": "Ogiltig signatur för PEC-stygnblocket.",
  "Invalid VP3 stitch block.": "Ogiltigt VP3-stygnblock.",
  "Invalid coordinates were generated. Check the shape.": "Ogiltiga koordinater genererades. Kontrollera formen.",
  "Invalid image data.": "Ogiltiga bilddata.",
  "Invalid long VP3 displacement.": "Ogiltig lång VP3-förflyttning.",
  "Invalid path data in SVG.": "Ogiltiga sökvägsdata i SVG.",
  "Invalid position {pos}": "Ogiltig position {pos}",
  "Invalid project: {msg}": "Ogiltigt projekt: {msg}",
  "Invalid section separator in CSewSeg.": "Ogiltig sektionsavgränsare i CSewSeg.",
  "Invalid start of the PEC stitch block.": "Ogiltig början på PEC-stygnblocket.",
  "Invalid stitch offset in the JEF header.": "Ogiltig stygnoffset i JEF-huvudet.",
  "JEF displacement outside ±127: {v}": "JEF-förflyttning utanför ±127: {v}",
  "JEF export does not support stops without a colour change.": "JEF-exporten stöder inte stopp utan färgbyte.",
  "JEF has no trim command; the machine trims jumps according to its own setting.": "JEF har inget klippkommando; maskinen klipper hopp enligt sin egen inställning.",
  "Janome, Elna and Kenmore": "Janome, Elna och Kenmore",
  "Jump records": "Hoppposter",
  "Jump sequence (Tajima convention)": "Hoppsekvens (Tajima-konvention)",
  "Jumps": "Hopp",
  "Jumps and trims": "Hopp och klipp",
  "Keep aspect ratio": "Behåll proportionerna",
  "Language": "Språk",
  "Last": "Sist",
  "Later": "Senare",
  "Line": "Linje",
  "Line (running stitch)": "Linje (raksöm)",
  "Line {n}": "Linje {n}",
  "Loading …": "Laddar …",
  "Lock": "Lås",
  "Lock against editing": "Lås mot redigering",
  "Lock aspect ratio": "Lås proportionerna",
  "Lock object": "Lås objektet",
  "Machine": "Maskin",
  "Make a patch (badge) around the design": "Gör ett märke (tygmärke) runt designen",
  "Make patch": "Gör märke",
  "Manual: use as background": "Manuellt: använd som bakgrund",
  "Max stitch length": "Max stygnlängd",
  "Max width before split": "Max bredd före delning",
  "Melco/Bernina and compatibles": "Melco/Bernina och kompatibla",
  "Merge": "Slå ihop",
  "Merge with another colour": "Slå ihop med en annan färg",
  "Merge with {colour}": "Slå ihop med {colour}",
  "Method": "Metod",
  "Minimum stitch length": "Minsta stygnlängd",
  "Minimum stitch length cannot be larger than the stitch length.": "Minsta stygnlängd kan inte vara större än stygnlängden.",
  "Missing migration from version {v}.": "Migrering från version {v} saknas.",
  "Mixed": "Blandat",
  "More…": "Mer…",
  "Move all objects to:": "Flytta alla objekt till:",
  "Move colour up": "Flytta färgen uppåt",
  "Move end point": "Flytta slutpunkt",
  "Move start point": "Flytta startpunkt",
  "Move up": "Flytta upp",
  "Nearest colour in the machine palette": "Närmaste färg i maskinens palett",
  "New colour": "Ny färg",
  "New project": "Nytt projekt",
  "No colours (colour changes only)": "Inga färger (bara färgbyten)",
  "No objects selected": "Inga objekt markerade",
  "No objects yet": "Inga objekt än",
  "No preview": "Ingen förhandsvisning",
  "No saved projects": "Inga sparade projekt",
  "No shapes found in the SVG file. Text must be converted to outlines before importing.": "Inga former hittades i SVG-filen. Text måste konverteras till konturer före import.",
  "No stitches to show. Add objects first.": "Inga stygn att visa. Lägg till objekt först.",
  "No stitches yet": "Inga stygn än",
  "Not a PEC file.": "Inte en PEC-fil.",
  "Not a PES file (missing the #PES signature).": "Inte en PES-fil (#PES-signaturen saknas).",
  "Not a VP3 file (missing %vsm%).": "Inte en VP3-fil (%vsm% saknas).",
  "Number of colours": "Antal färger",
  "Object": "Objekt",
  "Object list": "Objektlista",
  "Object name": "Objektnamn",
  "Object {n}": "Objekt {n}",
  "Objects": "Objekt",
  "Objects are sewn in list order. Grouping by colour (in palette order) gives the fewest colour changes, but may change which objects end up on top.": "Objekten sys i listordning. Gruppering efter färg (i palettordning) ger minst antal färgbyten, men kan ändra vilka objekt som hamnar överst.",
  "Objects in sewing order": "Objekt i sömnadsordning",
  "Objects · sewing order": "Objekt · sömnadsordning",
  "One stitch back": "Ett stygn bakåt",
  "One stitch forward": "Ett stygn framåt",
  "Open {name}": "Öppna {name}",
  "Order": "Ordning",
  "Original image": "Originalbild",
  "Original · drag to crop": "Original · dra för att beskära",
  "Oval": "Oval",
  "Overlap": "Överlappning",
  "Own trim command": "Eget klippkommando",
  "PEC displacement outside ±2047: {v}": "PEC-förflyttning utanför ±2047: {v}",
  "PEC/PES does not support stop commands without a colour change.": "PEC/PES stöder inte stoppkommandon utan färgbyte.",
  "PES does not support stop commands without a colour change.": "PES stöder inte stoppkommandon utan färgbyte.",
  "PES supports at most 255 colour blocks.": "PES stöder högst 255 färgblock.",
  "PES v6 stores the exact thread colours and names in the file. The machine sews from the PEC part, which shows the nearest Brother colour.": "PES v6 lagrar exakta trådfärger och namn i filen. Maskinen syr från PEC-delen, som visar närmaste Brother-färg.",
  "PNG, JPEG or SVG, max 25 MB. The image is processed only in your browser and is never uploaded. Transparency in PNG and SVG is used as background.": "PNG, JPEG eller SVG, max 25 MB. Bilden bearbetas bara i din webbläsare och laddas aldrig upp. Genomskinlighet i PNG och SVG används som bakgrund.",
  "Pan": "Panorera",
  "Parts of the design are outside the hoop with the chosen placement. Centre the design in the hoop.": "Delar av designen hamnar utanför ramen med vald placering. Centrera designen i ramen.",
  "Passes": "Passager",
  "Passes must be a whole number.": "Passager måste vara ett heltal.",
  "Patch": "Märke",
  "Patch added. The machine stops after the placement line (lay the fabric) and after the tack-down (trim away the excess).": "Märke tillagt. Maskinen stannar efter placeringslinjen (lägg på tyget) och efter fästsömmen (klipp bort överskottet).",
  "Patch added: background, design and satin border.": "Märke tillagt: bakgrund, design och plattsömskant.",
  "Patch preview": "Förhandsvisning av märket",
  "Patch shape": "Märkets form",
  "Patch – background": "Märke – bakgrund",
  "Patch – border": "Märke – kant",
  "Patch – placement (stop)": "Märke – placering (stopp)",
  "Patch – placement line": "Märke – placeringslinje",
  "Patch – satin border": "Märke – plattsömskant",
  "Patch – tack-down": "Märke – fästsöm",
  "Patch – tack-down (stop)": "Märke – fästsöm (stopp)",
  "Pause": "Paus",
  "Pfaff and Husqvarna Viking": "Pfaff och Husqvarna Viking",
  "Placement line → stop (lay the fabric) → tack-down → stop (trim away the fabric outside) → design → satin border.": "Placeringslinje → stopp (lägg på tyget) → fästsöm → stopp (klipp bort tyget utanför) → design → plattsömskant.",
  "Play": "Spela upp",
  "Polygon (fill)": "Polygon (fyllnad)",
  "Position": "Position",
  "Position and size": "Position och storlek",
  "Preview of the colour separation": "Förhandsvisning av färgsepareringen",
  "Project name": "Projektnamn",
  "Project not found.": "Projektet hittades inte.",
  "Project not found. It may have been deleted.": "Projektet hittades inte. Det kan ha tagits bort.",
  "Projects": "Projekt",
  "Projects are stored only in this browser (IndexedDB). Download the project file as a backup or to move the project to another computer.": "Projekten lagras bara i den här webbläsaren (IndexedDB). Ladda ner projektfilen som säkerhetskopia eller för att flytta projektet till en annan dator.",
  "Projects on this device": "Projekt på den här enheten",
  "Properties": "Egenskaper",
  "Pull compensation": "Dragkompensation",
  "Reading the image…": "Läser bilden…",
  "Ready for export": "Klar för export",
  "Rectangle": "Rektangel",
  "Rectangle (fill)": "Rektangel (fyllnad)",
  "Redo": "Gör om",
  "Remaining ≈ {time} (estimate)": "Återstår ≈ {time} (uppskattning)",
  "Remove patch": "Ta bort märket",
  "Remove solid background": "Ta bort enfärgad bakgrund",
  "Remove unused": "Ta bort oanvända",
  "Removed: {colour}": "Borttagen: {colour}",
  "Rename": "Byt namn",
  "Replace the existing design": "Ersätt den befintliga designen",
  "Reset crop": "Återställ beskärning",
  "Rotate (Shift = 15° steps)": "Rotera (Shift = steg om 15°)",
  "Rotation": "Rotation",
  "Rounded rectangle": "Rundad rektangel",
  "Row spacing": "Radavstånd",
  "Row spacing (density)": "Radavstånd (täthet)",
  "Run": "Rak",
  "Running stitch": "Raksöm",
  "Running stitch and satin run towards the end point. Fill starts and ends at the nearest possible row ends (where the rows are shortest).": "Raksöm och plattsöm går mot slutpunkten. Fyllnad börjar och slutar vid närmaste möjliga radändar (där raderna är kortast).",
  "SVG – vector import": "SVG – vektorimport",
  "Satin": "Plattsöm",
  "Satin column": "Plattsömskolumn",
  "Satin line": "Plattsömslinje",
  "Satin needs a shape without holes. Use fill stitch, or draw a satin column.": "Plattsöm kräver en form utan hål. Använd fyllnadsstygn eller rita en plattsömskolumn.",
  "Satin up to": "Plattsöm upp till",
  "Satin {n}": "Plattsöm {n}",
  "Save": "Spara",
  "Save current project": "Spara aktuellt projekt",
  "Save locally": "Spara lokalt",
  "Save what you are working on and it will show up here.": "Spara det du arbetar med så visas det här.",
  "Scale (Shift = keep proportions)": "Skala (Shift = behåll proportionerna)",
  "Scaling changes the shapes; the stitch density is kept, so the stitch count changes.": "Skalning ändrar formerna; stygntätheten behålls, så antalet stygn ändras.",
  "Select": "Markera",
  "Select an object on the canvas or in the object list to change its shape, colour and stitches. Draw new shapes with the tools on the left.": "Markera ett objekt på arbetsytan eller i objektlistan för att ändra form, färg och stygn. Rita nya former med verktygen till vänster.",
  "Select and move": "Markera och flytta",
  "Select objects with this colour": "Markera objekt med den här färgen",
  "Separate again": "Separera igen",
  "Settings": "Inställningar",
  "Sew connections shorter than": "Sy förbindelser kortare än",
  "Sew earlier": "Sy tidigare",
  "Sew later": "Sy senare",
  "Sew simulation": "Sömnadssimulering",
  "Sew this colour": "Sy den här färgen",
  "Sewing time": "Sömnadstid",
  "Sewing time (estimate)": "Sömnadstid (uppskattning)",
  "Shape": "Form",
  "Shapes": "Former",
  "Shield": "Sköld",
  "Short stitches in tight curves": "Korta stygn i snäva kurvor",
  "Show": "Visa",
  "Show (sew)": "Visa (sy)",
  "Show at actual size": "Visa i verklig storlek",
  "Show jumps and trims": "Visa hopp och klipp",
  "Show – the object is sewn and exported again": "Visa – objektet sys och exporteras igen",
  "Size": "Storlek",
  "Smallest detail": "Minsta detalj",
  "Smoothing": "Utjämning",
  "Speed": "Hastighet",
  "Split wide stitches": "Dela breda stygn",
  "Stagger (rows)": "Förskjutning (rader)",
  "Start a new embroidery design": "Starta en ny broderidesign",
  "Start, end and tie-off": "Start, slut och fästning",
  "Statistics": "Statistik",
  "Stitch angle": "Stygnriktning",
  "Stitch choices": "Stygnval",
  "Stitch error: {error}": "Stygnfel: {error}",
  "Stitch generation failed: {error}. Simplify the shape or change the stitch type.": "Stygngenereringen misslyckades: {error}. Förenkla formen eller byt stygntyp.",
  "Stitch length": "Stygnlängd",
  "Stitch position": "Stygnposition",
  "Stitch simulation": "Stygnsimulering",
  "Stitch type": "Stygntyp",
  "Stitch type for all": "Stygntyp för alla",
  "Stitches": "Stygn",
  "Tajima and most industrial machines": "Tajima och de flesta industrimaskiner",
  "Tatami underlay (90°)": "Tatami-underlägg (90°)",
  "Text in SVG is not supported. Convert the text to outlines (Object → Object to Path) before importing.": "Text i SVG stöds inte. Konvertera texten till konturer (Objekt → Objekt till bana) före import.",
  "The DST file is missing the end command (0xF3).": "DST-filen saknar slutkommandot (0xF3).",
  "The DST file is shorter than its header (512 bytes).": "DST-filen är kortare än sitt huvud (512 byte).",
  "The DST header is missing the LA field.": "DST-huvudet saknar LA-fältet.",
  "The EXP file has an odd number of bytes.": "EXP-filen har ett udda antal byte.",
  "The JEF file is missing the end code (0x80 0x10).": "JEF-filen saknar slutkoden (0x80 0x10).",
  "The PEC section is missing \"LA:\".": "PEC-sektionen saknar \"LA:\".",
  "The PEC stitch block is missing the end code (0xFF).": "PEC-stygnblocket saknar slutkoden (0xFF).",
  "The SVG drawing has no size.": "SVG-ritningen har ingen storlek.",
  "The SVG file could not be drawn. External resources and scripts are not supported.": "SVG-filen kunde inte ritas. Externa resurser och skript stöds inte.",
  "The SVG file could not be read.": "SVG-filen kunde inte läsas.",
  "The SVG file could not be read. Check that it is valid.": "SVG-filen kunde inte läsas. Kontrollera att den är giltig.",
  "The SVG shapes have neither fill nor stroke.": "SVG-formerna har varken fyllning eller linje.",
  "The VP3 design block is corrupt.": "VP3-designblocket är skadat.",
  "The VP3 design block is missing xxPP.": "VP3-designblocket saknar xxPP.",
  "The VP3 file block is longer than the file.": "VP3-filblocket är längre än filen.",
  "The background is filled with stitches. Sew on stabilizer and cut out along the edge.": "Bakgrunden fylls med stygn. Sy på mellanlägg och klipp ut längs kanten.",
  "The browser cannot draw the image (Canvas is missing).": "Webbläsaren kan inte rita bilden (Canvas saknas).",
  "The design ({w} × {h} mm) is larger than the hoop {hoop}. Scale the design down or choose a larger hoop.": "Designen ({w} × {h} mm) är större än ramen {hoop}. Skala ner designen eller välj en större ram.",
  "The design has a very large number of stitches ({n}). Many machines limit the stitch count; consider a lower density.": "Designen har mycket många stygn ({n}). Många maskiner begränsar antalet stygn; överväg en lägre täthet.",
  "The design has errors that must be fixed before export:": "Designen har fel som måste rättas före export:",
  "The design has no stitches to export. Add objects or digitize an image.": "Designen har inga stygn att exportera. Lägg till objekt eller digitalisera en bild.",
  "The design has {n} stitches (max {max}). Make the design smaller or increase the row spacing.": "Designen har {n} stygn (max {max}). Gör designen mindre eller öka radavståndet.",
  "The design is empty. The patch is created anyway, but import or draw the motif first to fit the size.": "Designen är tom. Märket skapas ändå, men importera eller rita motivet först för att anpassa storleken.",
  "The design is too large for {format}.": "Designen är för stor för {format}.",
  "The design is too large for {format}: coordinate ({x} mm, {y} mm) exceeds the format limit of ±{max} mm.": "Designen är för stor för {format}: koordinaten ({x} mm, {y} mm) överskrider formatets gräns på ±{max} mm.",
  "The design width must be greater than 0 mm.": "Designens bredd måste vara större än 0 mm.",
  "The file is empty.": "Filen är tom.",
  "The file is not a StitchCraft project.": "Filen är inte ett StitchCraft-projekt.",
  "The file is {size} MB. The maximum size is {max} MB – save the image at a lower resolution.": "Filen är {size} MB. Maxstorleken är {max} MB – spara bilden i lägre upplösning.",
  "The hoop must have a positive width and height.": "Ramen måste ha positiv bredd och höjd.",
  "The image could not be decoded. The file may be damaged.": "Bilden kunde inte avkodas. Filen kan vara skadad.",
  "The image could not be read: {error}": "Bilden kunde inte läsas: {error}",
  "The image has no visible content after transparency and background were removed. Turn off background removal or choose another image.": "Bilden har inget synligt innehåll efter att genomskinlighet och bakgrund tagits bort. Stäng av bakgrundsborttagning eller välj en annan bild.",
  "The image is empty.": "Bilden är tom.",
  "The image is too large ({w} × {h} pixels). The maximum is {max} megapixels.": "Bilden är för stor ({w} × {h} pixlar). Max är {max} megapixlar.",
  "The image is {w} × {h} pixels. The maximum is {max} megapixels.": "Bilden är {w} × {h} pixlar. Max är {max} megapixlar.",
  "The image was added as a background. Draw shapes on top with the tools (polygon, line, rectangle …).": "Bilden lades in som bakgrund. Rita former ovanpå med verktygen (polygon, linje, rektangel …).",
  "The line needs at least two points.": "Linjen behöver minst två punkter.",
  "The object produced no stitches. The shape may be too small for the selected stitch type.": "Objektet gav inga stygn. Formen kan vara för liten för vald stygntyp.",
  "The order below is the sewing order of the colours. Change a colour to move the borders between the colour areas.": "Ordningen nedan är färgernas sömnadsordning. Ändra en färg för att flytta gränserna mellan färgområdena.",
  "The original image in the project could not be read. The design was opened without an image.": "Originalbilden i projektet kunde inte läsas. Designen öppnades utan bild.",
  "The outer edge of the satin border is the edge of the patch. Actual size: {w} × {h} mm.": "Plattsömskantens ytterkant är märkets kant. Faktisk storlek: {w} × {h} mm.",
  "The outline crosses itself. It is interpreted with the even-odd rule; fix the nodes for a predictable result.": "Konturen korsar sig själv. Den tolkas med jämn-udda-regeln; justera noderna för ett förutsägbart resultat.",
  "The palette is empty. Digitize an image or add a colour.": "Paletten är tom. Digitalisera en bild eller lägg till en färg.",
  "The project file has no valid version number.": "Projektfilen saknar giltigt versionsnummer.",
  "The project file is not valid JSON.": "Projektfilen är inte giltig JSON.",
  "The project file is too large.": "Projektfilen är för stor.",
  "The project was made with a newer version (format {v}). Update StitchCraft to open it.": "Projektet skapades med en nyare version (format {v}). Uppdatera StitchCraft för att öppna det.",
  "The satin column is too short to produce stitches.": "Plattsömskolumnen är för kort för att ge stygn.",
  "The satin column needs two rails with at least two points each.": "Plattsömskolumnen behöver två skenor med minst två punkter vardera.",
  "The satin is up to {width} mm wide (max {max} mm). Enable splitting, make the shape narrower or use fill stitch.": "Plattsömmen är upp till {width} mm bred (max {max} mm). Aktivera delning, gör formen smalare eller använd fyllnadsstygn.",
  "The sewing time is a rough estimate based on the speed, colour changes and trims above. The actual time depends on the machine.": "Sömnadstiden är en grov uppskattning baserad på hastighet, färgbyten och klipp ovan. Den verkliga tiden beror på maskinen.",
  "The shape has no area. Delete the object or draw the shape again.": "Formen har ingen yta. Ta bort objektet eller rita formen igen.",
  "The shape is too narrow for fill stitch at this row spacing. Use satin or running stitch.": "Formen är för smal för fyllnadsstygn med det här radavståndet. Använd plattsöm eller raksöm.",
  "The shape is too narrow for underlay; underlay was left out.": "Formen är för smal för underlägg; underlägget utelämnades.",
  "The shape must have at least {n} points.": "Formen måste ha minst {n} punkter.",
  "The shapes in the SVG file are imported directly as editable curves: filled shapes become fill, and strokes become running stitch or satin. This gives the most precise edges. The colour settings below apply only to pixel-based digitizing.": "Formerna i SVG-filen importeras direkt som redigerbara kurvor: fyllda former blir fyllnad och linjer blir raksöm eller plattsöm. Det ger de mest exakta kanterna. Färginställningarna nedan gäller bara pixelbaserad digitalisering.",
  "This browser does not support local storage (IndexedDB).": "Den här webbläsaren stöder inte lokal lagring (IndexedDB).",
  "This file type is not supported. Use PNG, JPEG or SVG.": "Filtypen stöds inte. Använd PNG, JPEG eller SVG.",
  "Thread (top thread)": "Tråd (övertråd)",
  "Thread colour": "Trådfärg",
  "Thread palette": "Trådpalett",
  "Tie-in at start": "Fästning vid start",
  "Tie-off before trims": "Fästning före klipp",
  "Time per colour change": "Tid per färgbyte",
  "Time per trim": "Tid per klipp",
  "Timeline": "Tidslinje",
  "To end": "Till slutet",
  "To start": "Till början",
  "Too many colour changes for PEC (max 255).": "För många färgbyten för PEC (max 255).",
  "Tools": "Verktyg",
  "Tracing outlines": "Spårar konturer",
  "Trim jumps longer than": "Klipp hopp längre än",
  "Trims": "Klipp",
  "Trims are written as three jumps with no net movement (Tajima convention).": "Klipp skrivs som tre hopp utan nettoförflyttning (Tajima-konvention).",
  "Truncated EXP control record.": "Avkortad EXP-kontrollpost.",
  "Underlay": "Underlägg",
  "Undo": "Ångra",
  "Unexpected PEC icon format.": "Oväntat PEC-ikonformat.",
  "Unexpected PES v6 header.": "Oväntat PES v6-huvud.",
  "Unexpected end of file at byte {pos}": "Oväntat filslut vid byte {pos}",
  "Unknown": "Okänd",
  "Unknown EXP control code 0x{code}.": "Okänd EXP-kontrollkod 0x{code}.",
  "Unknown JEF control code 0x{code}.": "Okänd JEF-kontrollkod 0x{code}.",
  "Unknown SVG path command “{cmd}”.": "Okänt SVG-sökvägskommando ”{cmd}”.",
  "Unknown VP3 control code 0x{code}.": "Okänd VP3-kontrollkod 0x{code}.",
  "Unlock": "Lås upp",
  "Unsaved changes": "Osparade ändringar",
  "Untitled": "Namnlös",
  "Update patch": "Uppdatera märket",
  "Updating stitches…": "Uppdaterar stygn…",
  "Updating the stitches …": "Stygnen uppdateras …",
  "Use PES v1 if an older machine or program cannot open the file.": "Använd PES v1 om en äldre maskin eller ett äldre program inte kan öppna filen.",
  "Use satin on narrow areas": "Använd plattsöm på smala ytor",
  "VP3 export does not support stops without a colour change.": "VP3-exporten stöder inte stopp utan färgbyte.",
  "VP3 has no jump command; moves are stored as long displacements (normally right after a trim).": "VP3 har inget hoppkommando; förflyttningar lagras som långa förskjutningar (normalt direkt efter ett klipp).",
  "VP3 with {n} designs is not supported.": "VP3 med {n} designer stöds inte.",
  "Validate and download .{ext}": "Validera och ladda ner .{ext}",
  "Validation of {format} failed: {details}.": "Valideringen av {format} misslyckades: {details}.",
  "Verification read of {format} failed: {error}": "Kontrolläsningen av {format} misslyckades: {error}",
  "Very wide strokes are sewn as 12 mm satin. Convert them to filled shapes for a better result.": "Mycket breda linjer sys som 12 mm plattsöm. Konvertera dem till fyllda former för bättre resultat.",
  "View": "Visning",
  "Warning": "Varning",
  "Wide sections (up to {width} mm) are split into several stitches.": "Breda partier (upp till {width} mm) delas upp i flera stygn.",
  "Width": "Bredd",
  "Width (line)": "Bredd (linje)",
  "Width (stitches)": "Bredd (stygn)",
  "Your work has been restored from your last session.": "Ditt arbete har återställts från din senaste session.",
  "Zigzag spacing (same side)": "Sicksackavstånd (samma sida)",
  "Zigzag underlay": "Sicksack-underlägg",
  "Zoom": "Zooma",
  "Zoom in (+)": "Zooma in (+)",
  "Zoom out (−)": "Zooma ut (−)",
  "colour change": "färgbyte",
  "colour changes differ ({e} vs {a})": "färgbyten skiljer sig ({e} mot {a})",
  "colour {i} is invalid": "färg {i} är ogiltig",
  "crop": "utsnitt",
  "design is missing": "design saknas",
  "design is missing objects or palette": "designen saknar objekt eller palett",
  "end": "slut",
  "estimate": "uppskattning",
  "fill": "fyllnad",
  "height": "höjd",
  "id is missing": "id saknas",
  "image data is invalid": "bilddata är ogiltiga",
  "invalid": "ogiltig",
  "jump": "hopp",
  "locked": "låst",
  "missing": "saknas",
  "move {i}: expected ({ex}, {ey}{ej}), found ({ax}, {ay}{aj})": "förflyttning {i}: förväntade ({ex}, {ey}{ej}), hittade ({ax}, {ay}{aj})",
  "not sewn": "sys inte",
  "number of moves: expected {e}, found {a}": "antal förflyttningar: förväntade {e}, hittade {a}",
  "object {i} has an invalid shape": "objekt {i} har en ogiltig form",
  "object {i} has no id/colour": "objekt {i} saknar id/färg",
  "object {i} has no transform": "objekt {i} saknar transformation",
  "object {i} is invalid": "objekt {i} är ogiltigt",
  "open": "öppen",
  "rotation": "rotation",
  "running stitch": "raksöm",
  "satin": "plattsöm",
  "scale": "skala",
  "stitch": "stygn",
  "stitch parameters are missing": "stygnparametrar saknas",
  "stop": "stopp",
  "trim": "klipp",
  "trims differ ({e} vs {a})": "klipp skiljer sig ({e} mot {a})",
  "unknown image type {mime}": "okänd bildtyp {mime}",
  "unknown stitch type {type}": "okänd stygntyp {type}",
  "was written, read back and checked against the internal stitch sequence.": "har skrivits, lästs tillbaka och kontrollerats mot den interna stygnsekvensen.",
  "width": "bredd",
  "{h} h {m} min": "{h} h {m} min",
  "{kind} · no. {n} of {total} in the sewing order · {stitches} stitches": "{kind} · nr {n} av {total} i sömnadsordningen · {stitches} stygn",
  "{label} must be between {min} and {max}{unit} (is {value}).": "{label} måste vara mellan {min} och {max}{unit} (är {value}).",
  "{m} min {s} s": "{m} min {s} s",
  "{name} (copy)": "{name} (kopia)",
  "{name} · {type} · {n} stitches": "{name} · {type} · {n} stygn",
  "{n} cmd/s": "{n} kmd/s",
  "{n} error(s)": "{n} fel",
  "{n} hidden object ({names}) is not in the file. Show it in the object list if it should be sewn.": "{n} dolt objekt ({names}) finns inte i filen. Visa det i objektlistan om det ska sys.",
  "{n} hidden objects ({names}) are not in the file. Show them in the object list if they should be sewn.": "{n} dolda objekt ({names}) finns inte i filen. Visa dem i objektlistan om de ska sys.",
  "{n} hidden – not sewn": "{n} dolda – sys inte",
  "{n} objects": "{n} objekt",
  "{n} objects selected": "{n} objekt markerade",
  "{n} points · Enter/double-click finishes · Backspace removes a point · Esc cancels": "{n} punkter · Enter/dubbelklick avslutar · Backsteg tar bort en punkt · Esc avbryter",
  "{n} problem(s) in the design must be fixed before export.": "{n} problem i designen måste rättas före export.",
  "{n} small areas were merged.": "{n} små områden slogs ihop.",
  "{n} warning(s)": "{n} varningar",
  "{s} s": "{s} s",
  "{what} must be a number": "{what} måste vara ett tal",
  "“{name}” is saved locally in the browser.": "”{name}” är sparat lokalt i webbläsaren.",
  "“{name}” uses a colour that is not in the palette. Choose a new colour.": "”{name}” använder en färg som inte finns i paletten. Välj en ny färg.",
  "New": "Nytt",
  "Start a new project?": "Starta ett nytt projekt?",
  "“{name}” has unsaved changes. Do you want to save them before you start a new project?": "”{name}” har osparade ändringar. Vill du spara dem innan du startar ett nytt projekt?",
  "Discard changes": "Kasta ändringarna",
  "Save and start new": "Spara och starta nytt",
  "Enter saves · Esc cancels": "Enter sparar · Esc avbryter",
  "Measure": "Mät",
  "Length {len} mm ({inch} in) · Δx {dx} mm · Δy {dy} mm · angle {angle}°": "Längd {len} mm ({inch} tum) · Δx {dx} mm · Δy {dy} mm · vinkel {angle}°",
  "Click two points to measure · Shift = 15° steps · snaps to nodes · Esc clears": "Klicka på två punkter för att mäta · Shift = steg om 15° · fäster mot noder · Esc rensar",
  "Embroidery machine": "Broderimaskin",
  "Generic (all hoop sizes)": "Allmän (alla ramstorlekar)",
  "Only the hoops this machine accepts are shown. Check the sizes against the manual for your machine.": "Endast ramarna som maskinen kan använda visas. Kontrollera storlekarna mot handboken för din maskin.",
  "File name": "Filnamn",
  "Change the name in the top bar.": "Ändra namnet i det övre fältet.",
  "Import an image (PNG, JPEG or SVG) for automatic digitizing, or draw shapes yourself with the tools below.": "Importera en bild (PNG, JPEG eller SVG) för automatisk digitalisering, eller rita former själv med verktygen nedan.",
  "Menu": "Meny",
  "Import": "Importera",
  "More": "Mer",
  "Simulate": "Simulera",
  "Delete node": "Ta bort nod",
  "Copy": "Kopiera",
  "Cut": "Klipp ut",
  "Paste": "Klistra in",
  "A new code is on its way to {email}. You can ask for a new code once a minute.": "En ny kod är på väg till {email}. Du kan be om en ny kod en gång i minuten.",
  "A test email is sent to {email}.": "Ett testmejl har skickats till {email}.",
  "Account": "Konto",
  "Account: {email}": "Konto: {email}",
  "Accounts are not available on this server.": "Konton är inte tillgängliga på den här servern.",
  "Active": "Aktiv",
  "Administration": "Administration",
  "Administrator": "Administratör",
  "Back to log in": "Tillbaka till inloggning",
  "Block": "Spärra",
  "Blocked": "Spärrad",
  "Brevo API key": "API-nyckel för Brevo",
  "Change password": "Byt lösenord",
  "Choose a new password": "Välj nytt lösenord",
  "Code from the email": "Kod från mejlet",
  "Confirm": "Bekräfta",
  "Confirm your email address": "Bekräfta e-postadressen",
  "Confirm your email address first. Enter the code we sent you.": "Bekräfta e-postadressen först. Ange koden vi skickade till dig.",
  "Create account": "Skapa konto",
  "Create an account": "Skapa konto",
  "Created {date}": "Skapad {date}",
  "Current password": "Nuvarande lösenord",
  "Delete user": "Ta bort användare",
  "Delete {email} and their cloud projects": "Ta bort {email} och molnprojekten",
  "Email": "E-post",
  "Emails (codes for confirming addresses and resetting passwords) are sent with Brevo.": "E-post (koder för att bekräfta adresser och återställa lösenord) skickas med Brevo.",
  "Enter a valid email address.": "Ange en giltig e-postadress.",
  "Forgot password": "Glömt lösenord",
  "Forgot password?": "Glömt lösenordet?",
  "If {email} has an account, we have sent a code to it.": "Om {email} har ett konto har vi skickat en kod dit.",
  "In the cloud": "I molnet",
  "In this browser": "I den här webbläsaren",
  "Log in": "Logga in",
  "Log out": "Logga ut",
  "Logged in as {email}.": "Inloggad som {email}.",
  "Make admin": "Gör till administratör",
  "Member since": "Medlem sedan",
  "New password": "Nytt lösenord",
  "New password (at least {n} characters)": "Nytt lösenord (minst {n} tecken)",
  "No API key: emails cannot be sent.": "Ingen API-nyckel: e-post kan inte skickas.",
  "No connection to the server.": "Ingen anslutning till servern.",
  "Not confirmed": "Inte bekräftad",
  "Not found.": "Hittades inte.",
  "Password": "Lösenord",
  "Password (at least {n} characters)": "Lösenord (minst {n} tecken)",
  "Remove admin role": "Ta bort administratörsrollen",
  "Remove the stored key": "Ta bort den sparade nyckeln",
  "Role": "Roll",
  "Save new password": "Spara nytt lösenord",
  "Search by email": "Sök på e-post",
  "Send a new code": "Skicka ny kod",
  "Send a test email to {email}": "Skicka testmejl till {email}",
  "Send code": "Skicka kod",
  "Sender address": "Avsändaradress",
  "Sender name": "Avsändarnamn",
  "Show more": "Visa fler",
  "Something went wrong on the server. Try again.": "Något gick fel på servern. Försök igen.",
  "Stored ({hint}) – leave empty to keep it": "Sparad ({hint}) – lämna tomt för att behålla den",
  "Superadmin": "Superadmin",
  "The API key comes from the server environment (BREVO_API_KEY).": "API-nyckeln kommer från servermiljön (BREVO_API_KEY).",
  "The API key is stored here (encrypted).": "API-nyckeln är sparad här (krypterad).",
  "The code has expired. Ask for a new code.": "Koden har gått ut. Be om en ny kod.",
  "The code is not correct.": "Koden är inte rätt.",
  "The email could not be sent. Try again later or contact the administrator.": "Mejlet kunde inte skickas. Försök igen senare eller kontakta administratören.",
  "The email could not be sent: {detail}": "Mejlet kunde inte skickas: {detail}",
  "The email settings are saved.": "E-postinställningarna är sparade.",
  "The password is changed. Other devices are logged out.": "Lösenordet är bytt. Andra enheter har loggats ut.",
  "The password must be at least {n} characters.": "Lösenordet måste ha minst {n} tecken.",
  "The project could not be stored.": "Projektet kunde inte sparas.",
  "The project is too large to store in the cloud.": "Projektet är för stort för att sparas i molnet.",
  "The sender address must be a verified sender or domain in Brevo.": "Avsändaradressen måste vara en verifierad avsändare eller domän i Brevo.",
  "This account is blocked. Contact the administrator.": "Kontot är spärrat. Kontakta administratören.",
  "Too many attempts. Wait a little and try again.": "För många försök. Vänta en stund och försök igen.",
  "Too many wrong attempts. Ask for a new code.": "För många felaktiga försök. Be om en ny kod.",
  "Unblock": "Häv spärr",
  "User": "Användare",
  "Users": "Användare",
  "We have sent a code to {email}. If the address already has an account, log in instead.": "Vi har skickat en kod till {email}. Om adressen redan har ett konto loggar du in i stället.",
  "With an account you can store projects in the cloud and open them on other devices. Without one, StitchCraft works as before, in this browser only.": "Med ett konto kan du spara projekt i molnet och öppna dem på andra enheter. Utan konto fungerar StitchCraft som tidigare, bara i den här webbläsaren.",
  "Wrong email or password.": "Fel e-post eller lösenord.",
  "You are logged out. Projects in this browser are still here.": "Du är utloggad. Projekten i den här webbläsaren finns kvar.",
  "You are not logged in.": "Du är inte inloggad.",
  "You do not have access to this.": "Du har inte behörighet till detta.",
  "You have reached the maximum number of cloud projects. Delete some first.": "Du har nått maxantalet molnprojekt. Ta bort några först.",
  "Your email address is not confirmed yet. We have sent a new code to {email}.": "E-postadressen är inte bekräftad än. Vi har skickat en ny kod till {email}.",
  "last logged in {date}": "senast inloggad {date}",
  "never logged in": "aldrig inloggad",
  "{n} cloud projects": "{n} molnprojekt",
  "{n} users": "{n} användare",
  "“{name}” is saved in the browser and in the cloud.": "”{name}” är sparat i webbläsaren och i molnet.",
  "“{name}” is saved in the browser, but not in the cloud: {error}": "”{name}” är sparat i webbläsaren men inte i molnet: {error}",
  "“{name}” is saved in the cloud.": "”{name}” är sparat i molnet.",
  "1 user": "1 användare",
  "Hide this tip": "Dölj tipset",
  "While you are logged in, everything you save is stored in the cloud and can be opened on all your devices.": "När du är inloggad sparas allt du sparar i molnet, och du kan öppna det på alla dina enheter.",
  "You are logged in as {email}: projects are saved in the cloud, with a copy in this browser.": "Du är inloggad som {email}: projekten sparas i molnet, med en kopia i den här webbläsaren.",
  "Projects are saved in this browser.": "Projekten sparas i den här webbläsaren.",
  "Log in to save them in the cloud.": "Logga in för att spara dem i molnet.",
  "{n} projects are only in this browser.": "{n} projekt finns bara i den här webbläsaren.",
  "Upload them to the cloud": "Ladda upp dem till molnet",
  "The folder is empty": "Mappen är tom",
  "Move projects here with “Move to folder”, or save the current project while the folder is open.": "Flytta hit projekt med ”Flytta till mapp”, eller spara det aktuella projektet medan mappen är öppen.",
  "Folders": "Mappar",
  "All projects": "Alla projekt",
  "No folder": "Utan mapp",
  "New folder": "Ny mapp",
  "Folder name": "Mappnamn",
  "Create": "Skapa",
  "Rename folder": "Byt namn på mappen",
  "Delete the folder (the projects are kept)": "Ta bort mappen (projekten behålls)",
  "Delete folder": "Ta bort mapp",
  "Move to folder": "Flytta till mapp",
  "Delete everywhere": "Ta bort överallt",
  "Only from this browser": "Bara från den här webbläsaren",
  "Only from the cloud": "Bara från molnet",
  "Upload to the cloud": "Ladda upp till molnet",
  "More actions for {name}": "Fler val för {name}",
  "Make a copy": "Gör en kopia",
  "Delete “{name}”": "Ta bort ”{name}”",
};
